import { getToken } from '../../Utils/authUtils';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { HL7 } from '../../constant';

export interface GetLocalProvidersPayload {
  serverType?: 'equator' | 'capricorn';
}

export const getLocalProvidersApi = createAsyncThunk(
  'hl7/getLocalProviders',
  async (payload: GetLocalProvidersPayload | void, { rejectWithValue }) => {
    try {
      const token = getToken();
      if (!token) {
        return rejectWithValue('No token found');
      }
      const params = payload && payload.serverType
        ? `?serverType=${payload.serverType}`
        : '';
      const response = await fetch(`${HL7.PROVIDER_LOCAL}${params}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
      });

      const result = await response.json();
      if (!response.ok) {
        return rejectWithValue(result.msg || `Get local providers failed: ${response.status}`);
      }
      return result;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
